import React, { FC } from 'react';
import { HighlightedCard } from '@edreamsodigeo/prisma-design-system';

export type AlternativeItineraryDecoratorProps = {
  onClick?: (e?) => void;
  isAlternativeItineraryOnModal?: boolean;
  children: React.ReactNode;
};
const AlternativeItineraryDecorator: FC<AlternativeItineraryDecoratorProps> = ({
  onClick,
  isAlternativeItineraryOnModal,
  children,
}) => {
  return (
    <HighlightedCard
      type="positive"
      onClick={onClick}
      sx={{
        ...(isAlternativeItineraryOnModal && {
          boxSizing: 'content-box',
          maxHeight: '168px',
        }),
        zIndex: 1,
        position: 'relative',
      }}
    >
      {children}
    </HighlightedCard>
  );
};

export default AlternativeItineraryDecorator;
